import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Card,
  CardContent,
  CardActions,
  Button,
  Grid,
  Divider,
} from '@mui/material';
import {
  AdminPanelSettings as AdminPanelSettingsIcon,
  Business as BusinessIcon,
  SupervisorAccount as SupervisorAccountIcon,
} from '@mui/icons-material';
import AddCompanyForm from '../components/superuser/AddCompanyForm';
import ManageSuperuserStatus from '../components/superuser/ManageSuperuserStatus';

const SuperuserActions: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Superuser Actions
        </Typography>
        <Typography variant="body2" color="text.secondary">
          System-level administrative actions for managing the platform.
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {/* Add New Company Action */}
        <Grid item xs={12}>
          <AddCompanyForm />
        </Grid>

        <Grid item xs={12}>
          <Divider sx={{ my: 2 }} />
        </Grid>

        {/* Manage Superuser Status */}
        <Grid item xs={12}>
          <ManageSuperuserStatus />
        </Grid>
      </Grid>
    </Container>
  );
};

export default SuperuserActions;
